/**
 * A random name for THIS open screen, new at every page load.
 *
 * Sent with every job-page save (D10). The server remembers which screen
 * made the last change, and never refuses a screen over its own: the save a
 * screen sends while its tab is hidden or closing has no answer, so the
 * screen cannot know its count moved.
 */
const random = (): string =>
  typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : // Long enough for the server to take it for a page-load name (20+).
      `screen-${Date.now().toString(36)}-${Math.random()
        .toString(36)
        .slice(2)
        .padEnd(12, '0')}`;

export const SCREEN_NAME = random();

/**
 * A number for every save this screen sends, each higher than the last. The
 * server never stores a send from this screen that is older than the last
 * one it stored from it: a save that hung and arrives after its own retry
 * would put older words over newer ones.
 */
let sends = 0;
export const nextSendNo = (): number => {
  sends += 1;
  return sends;
};
